const AvatarIcon = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 7.75C5.05859 7.75 3.5 6.19141 3.5 4.25C3.5 2.33594 5.05859 0.75 7 0.75C8.91406 0.75 10.5 2.33594 10.5 4.25C10.5 6.19141 8.91406 7.75 7 7.75ZM5.74219 9.0625H8.23047C10.9375 9.0625 13.125 11.25 13.125 13.957C13.125 14.3945 12.7422 14.75 12.3047 14.75H1.66797C1.23047 14.75 0.875 14.3945 0.875 13.957C0.875 11.25 3.03516 9.0625 5.74219 9.0625Z" fill="#736F67"/>
  </svg>
);

export default AvatarIcon;
